import { Aggregate, AggregateColumnDirective, AggregateColumnsDirective, AggregateDirective, AggregatesDirective, ColumnDirective, ColumnsDirective, CommandClickEventArgs, CommandColumn, CommandModel, Filter, FilterSettingsModel, GridComponent, Inject } from '@syncfusion/ej2-react-grids'
import CustomCard from '../../components/CustomCard.tsx'

import { useOidcAccessToken, useOidcUser } from '@axa-fr/react-oidc'
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks.tsx'
import { OidcUserExtendedInfo } from '../../types/OidcUserExtendedInfo.tsx'
import { protectedResources } from '../../global/config.tsx'
import { useEffect, useRef } from 'react'
import { fetchAllDocentFromApi, fetchRequestedDocentFromApi } from '../../redux/docentSlice.tsx'
import { DialogComponent } from '@syncfusion/ej2-react-popups'
import { MenuHeaderBar } from '../../components/global/MenuHeaderBar.tsx'
import { useNavigate } from 'react-router'
import useUserRoles from '../../hooks/useUserRoles.tsx'
import { NwLecturerApplicationDto } from '../../types/NwLecturerApplicationDto.tsx'
import { clearAddressNr } from '../../redux/appSlice.tsx'
import { clearRegistrations, setSelectedRegistration } from '../../redux/registerSlice.tsx'

export const InstructorList = () => {
  const dispatch = useAppDispatch()
  const { accessToken } = useOidcAccessToken()
  const { oidcUser } = useOidcUser<OidcUserExtendedInfo>()
  const navigate = useNavigate()

  const dlgPromptDelDocent = useRef<DialogComponent | null>(null)

  const docentList = useAppSelector((state) => state.docent.docentList)
  const docentRequestedList = useAppSelector((state) => state.docent.docentRequestedList)

  const { isInternal } = useUserRoles()


  const apiCallAllDocents = () => {
    const url = `${protectedResources.apiList.readAllDocent}`
    if (accessToken && isInternal) {
      dispatch(fetchAllDocentFromApi({ url: url, token: accessToken }))
    }
  }

  const apiCallRequestedDocents = () => {
    const url = `${protectedResources.apiList.readRequestedDocent}`
    if (accessToken && isInternal) {
      dispatch(fetchRequestedDocentFromApi({ url: url, token: accessToken }))
    }
  }

  useEffect(() => {
    if (oidcUser !== null) {
      dispatch(clearAddressNr())
      dispatch(clearRegistrations())
      dispatch(clearRegistrations())
      apiCallAllDocents()
      apiCallRequestedDocents()

    }
  }, [accessToken, oidcUser])

  const commands: CommandModel[] = [
    {
      title: 'Profil',
      buttonOption: { cssClass: 'e-flat btnTransferSemi', iconCss: 'e-icons e-search-3', disabled: false },
    },
    {
      title: 'Antrag ablehnen',
      buttonOption: { cssClass: 'e-flat', iconCss: 'e-icons e-trash' },
    },
  ]

  const clickGrid = (props: CommandClickEventArgs) => {
    if (import.meta.env.DEV) {
      console.log(JSON.stringify(props.rowData))
    }

    const selectedDocent = props.rowData as NwLecturerApplicationDto
    switch (props.commandColumn?.title) {
      case 'Profil':
        setTimeout(() => {
          //dispatch(setSelectedDocentId(selectedDocent.adrId))
          //dispatch(setAddressNr(selectedDocent.adrNo))
          dispatch(setSelectedRegistration(selectedDocent))
          navigate(`/profile`)
        })
        break

      case 'Antrag ablehnen':
        setTimeout(() => {
          dlgPromptDelDocent.current?.show()
        })
        break
    }
  }


  const filterOptions: FilterSettingsModel = {
    type: 'FilterBar',
    mode: 'Immediate',
  }

  const footerCount = (props: any) => {
    return (<span>Anzahl: {props.Count}</span>)
  }

  return (
    <>

      <MenuHeaderBar headerContent={'Dozentenübersicht'} />
      <div className={'nw-content'} style={{ display: 'flex', flexDirection: 'column', overflowX: 'auto' }}>
        <div style={{ height: '30%', display: 'flex', flex: '1' }}>
          <CustomCard header=" Dozenten">
            <GridComponent dataSource={docentList} commandClick={clickGrid} height={'100%'} allowFiltering={true} filterSettings={filterOptions}>
              <ColumnsDirective>
                <ColumnDirective field="sub" headerText="Id" isPrimaryKey visible={false} />
                <ColumnDirective headerText="#" allowFiltering={false} textAlign="Center" commands={commands} width={'140px'} />
                <ColumnDirective field="adrNo" headerText="Adr-Nr." width={'120px'} headerTextAlign={'Center'} textAlign="Center" />
                <ColumnDirective field="contactForename" headerText="Vorname" />
                <ColumnDirective field="contactSurname" headerText="Nachname" />
                <ColumnDirective field="adrStreet" headerText="Straße" />
                <ColumnDirective field="adrPostCode" headerText="PLZ" width={'150px'} headerTextAlign={'Center'} textAlign="Center" />
                <ColumnDirective field="actualIndex" headerText="Profil-Versionen" width={'150px'} headerTextAlign={'Center'} textAlign="Center" />
              </ColumnsDirective>
              <AggregatesDirective>
                <AggregateDirective>
                  <AggregateColumnsDirective>
                    <AggregateColumnDirective field="actualIndex" type="Count" footerTemplate={footerCount} />
                  </AggregateColumnsDirective>
                </AggregateDirective>
              </AggregatesDirective>
              <Inject services={[CommandColumn, Filter, Aggregate]} />
            </GridComponent>
          </CustomCard>
        </div>
        <div style={{ height: '70%', display: 'flex', flex: '1' }}>
          <CustomCard header="offene Bewerbungen">
            <GridComponent dataSource={docentRequestedList} commandClick={clickGrid} rowHeight={30} height={'100%'} allowFiltering={true} filterSettings={filterOptions}>
              <ColumnsDirective>
                <ColumnDirective field="sub" headerText="Id" isPrimaryKey visible={false} />
                <ColumnDirective headerText="#" allowFiltering={false} textAlign="Center" commands={commands} width={'140px'} />
                <ColumnDirective field="contactForename" headerText="Vorname" />
                <ColumnDirective field="contactSurname" headerText="Nachname" />
                <ColumnDirective field="adrStreet" headerText="Straße" />
                <ColumnDirective field="adrPostCode" headerText="PLZ" width={'150px'} headerTextAlign={'Center'} textAlign="Center" />
              </ColumnsDirective><AggregatesDirective>
              <AggregateDirective>
                <AggregateColumnsDirective>
                  <AggregateColumnDirective field="adrPostCode" type="Count" footerTemplate={footerCount} />
                </AggregateColumnsDirective>
              </AggregateDirective>
            </AggregatesDirective>
              <Inject services={[CommandColumn, Filter, Aggregate]} />
            </GridComponent>
          </CustomCard>

        </div>


        {/* <DialogComponent ref={dlgPromptDelDocent} width="500px" height="350px" isModal={true} visible={false} showCloseIcon={false} closeOnEscape={false} target=".nw-app" cssClass="customDialog">
          <>
            <div className="dialogHeader">
              <div className="e-dlg-header-content">
                <div className="e-dlg-header">Antrag ablehnen</div>
              </div>
            </div>
            <div className="dialogContent">
              <p>Bitte geben Sie einen Grund für das Ablehnen dieses Antrages an:</p>
              <TextBoxComponent placeholder="Grund" floatLabelType="Always"></TextBoxComponent>
            </div>
            <div className="dialogFooter">
              <ButtonComponent onClick={handleBtnCancelPromptClick}>Abbrechen</ButtonComponent>
              <ButtonComponent onClick={handleBtnOkPromptClick} isPrimary>
                Ablehnen
              </ButtonComponent>
            </div>
          </>
        </DialogComponent> */}
      </div>
    </>
  )
}
